import { Box, Tooltip, Typography } from '@mui/material'
import { isString, merge } from 'lodash'
import { HelpCircle } from 'lucide-react'
import { isValidElement } from 'react'

export const TitleSection = ({
  title,
  subTitle,
  actions,
  titleVariant = 'h3',
  subTitleVariant = 'textPrimary',
  subTitleColor = 'text.secondary',
  tooltipMessage = '',
  icon,
  sx = {},
  tooltipProps = {},
}) => {
  return (
    <Box
      sx={merge(
        {
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          gap: '15px',

          '@media (max-width: 600px)': {
            flexWrap: 'wrap',
          },
        },
        sx
      )}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '4px',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
          }}
        >
          {icon}
          {isString(title) && title ? (
            <Typography variant={titleVariant}>{title}</Typography>
          ) : isValidElement(title) ? (
            title
          ) : null}
          {tooltipMessage && (
            <Tooltip title={tooltipMessage} placement="top" {...tooltipProps}>
              <Box
                sx={{
                  color: 'text.secondary',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <HelpCircle size={12} />
              </Box>
            </Tooltip>
          )}
        </Box>
        {isString(subTitle) && subTitle ? (
          <Typography variant={subTitleVariant} color={subTitleColor} sx={{}}>
            {subTitle}
          </Typography>
        ) : isValidElement(subTitle) ? (
          subTitle
        ) : null}
      </Box>
      {actions}
    </Box>
  )
}
